export const EN = "EN";
export const LT = "LT";
